<div class="d-flex flex-row flex-nowrap align-items-center">
  <div class="option-group-description d-inline-block text-start">
    <span
      *ngIf="optionGroup?.minRequired > 0"
      class="badge rounded-pill d-flex flex-row flex-nowrap py-1 align-items-center font-size-small"
      [ngClass]="
        menuService.groupCheck(optionGroup, optionGroups)
          ? 'bg-success'
          : 'bg-warning'
      "
      [attr.aria-live]="'polite'"
      [attr.role]="'status'">
      {{
        menuService.groupCheck(optionGroup, optionGroups)
          ? 'Complete'
          : 'Required'
      }}&nbsp;<i
      class="bi"
      [ngClass]="
          menuService.groupCheck(optionGroup, optionGroups)
            ? 'bi-check-circle'
            : 'bi-exclamation-circle'
        "
      aria-hidden="true"></i>
    </span>
    <span
      *ngIf="optionGroup?.minRequired === 0"
      class="badge rounded-pill d-flex flex-row flex-nowrap py-1 align-items-center font-size-small"
      [ngClass]="
        menuService.groupCheck(optionGroup, optionGroups)
          ? 'bg-success'
          : 'bg-secondary'
      "
      [attr.aria-live]="'polite'"
      [attr.role]="'status'">
      {{
        menuService.groupCheck(optionGroup, optionGroups)
          ? 'Complete'
          : 'Optional'
      }}
      <ng-container *ngIf="menuService.groupCheck(optionGroup, optionGroups)"
      >&nbsp;<i class="bi bi-check-circle" aria-hidden="true"></i
      ></ng-container>
    </span>
  </div>
  <div
    *ngIf="
      optionGroup?.maxAllowed > 0 &&
      optionGroup?.maxAllowed === optionGroup.minRequired
    "
    class="option-group-description d-inline-block text-end ms-auto">
    Choose {{ optionGroup?.maxAllowed }}
  </div>
  <div
    *ngIf="optionGroup?.maxAllowed === 0 && optionGroup?.minRequired === 0"
    class="option-group-description d-inline-block text-end ms-auto">
    Choose Any Amount
  </div>
  <div
    *ngIf="optionGroup?.maxAllowed !== optionGroup?.minRequired"
    class="option-group-description d-inline-block text-end ms-auto">
    Choose Up To {{ optionGroup?.maxAllowed }}
  </div>
</div>

<!-- Hidden but available to screen readers -->
<div class="sr-only" aria-live="polite">
  {{ optionGroup?.name }} -
  {{ optionGroup?.minRequired > 0 ? 'Required' : 'Optional' }} -
  {{ menuService.groupCheck(optionGroup, optionGroups) ? 'Complete' : (optionGroup?.minRequired > 0 ? 'Incomplete' : '') }}
  {{ optionGroup?.maxAllowed === optionGroup?.minRequired ? 'Choose exactly ' + optionGroup?.maxAllowed : '' }}
  {{ optionGroup?.maxAllowed !== optionGroup?.minRequired ? 'Choose up to ' + optionGroup?.maxAllowed : '' }}
  {{ optionGroup?.maxAllowed === 0 && optionGroup?.minRequired === 0 ? 'Choose any amount' : '' }}
</div>